module.exports = __webpack_public_path__ + "static/media/brushsmoothness.3147d4a2.svg";